<template>
<div v-show="isModalVisible">
<div class="modal-mask" @click="closeModal">
      <div class="modal-container" @click.stop>
      <!-- Modal Header -->
      <div class="modal-header">
        <h6 class="modal-title">Change Onboarding Date</h6>
        <button type="button" class="close" data-dismiss="modal" @click="closeModal">&times;</button>
      </div>
      <!-- Modal body -->
      <div class="modal-body">

        <div class="form-group row">
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <date-picker
                  v-model="follow_date"
                  format="MM/DD/YYYY"
                  v-bind:clearable="false"
                  input-class="col-md-12 input-height-30 padding-lr-5"
                  >
                  <template v-slot:icon-calendar>
                    <i class="fa fa-calendar red-color" aria-hidden="true"></i>
                  </template>
                </date-picker>



            </div>
        </div>
        <div class="text-center" style="margin-top: 70px;">
            <button type="submit" class="btn btn-sm ma-blue-btn" @click="saveRenewDate()">Save</button>
        </div>

      </div>
     </div>

</div>
</div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import VeeValidate from 'vee-validate';
import axios from 'axios';
Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import moment from 'moment';

  const today1 = new Date();
  today1.setHours(0, 0, 0, 0);

export default {
  props: [
    'isModalVisible',
    'accountId',
  
    ],
  data() {
    return {
        loading: false,
        mentee_submit_comment_selected: false,
        menteeId: '',
        submit_comment_checked: 0,
        index: '',
        follow_date: today1,
        renewaldate: '',
    }
  },
  components: {
    DatePicker
  },
  methods: {
        close() {
          this.$emit('close');
        },
        FollowDate(value) {
          return moment(String(value)).utc().format('ddd. MMM. D, YYYY - h:mm A')
        },
        notBeforeToday(date) {
          const today = new Date(this.renewaldate);
          today.setHours(0, 0, 0, 0);
          return date < today;
        },
        initial(date) {
          this.renewaldate = date;
          const today2 = new Date(this.renewaldate);
          today2.setHours(0, 0, 0, 0);
          this.follow_date = today2;
        },
        saveRenewDate: function() {
          if(this.accountId > 0) {

                const followDateStr = moment(this.follow_date).format('YYYY-MM-DD HH:mm:ss')
                axios('/save-onboardingdate',
                 {
                   method: 'POST',
                   data:
                    {
                      date: followDateStr,
                      account_id: this.accountId,
                    },
                 }
                )
                .then((resp) => {
                  this.$parent.closeBoardingDateModal();
                })
                .catch(error => {
                });

          }

        },
    closeModal() {
      this.$validator.errors.clear();
      this.$emit('close');
    },
    getAdminDetail(user) {        
        this.menteeId = user.uid;
        this.mentee_submit_comment_selected = user.mentee_submit_comment;
        this.submit_comment_checked = 
        user.mentee_submit_comment;
    },
    navigate(){
        this.$router.push(this.$router.currentRoute.fullPath)
        this.$router.go();
    }
  },
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  margin: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  transition: opacity .3s ease;
  overflow-y: scroll;
}
.modal-container {
  position: fixed;
  left: 50%;
  top: 50%;
  -ms-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 500px;
  height: auto;
  overflow-y: auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
}
.modal-body {
  margin: 0px;
  padding: 10px;
}
.modal-header .sub-heading {
  background-color: #FFF;
  color: #555;
}
.modal-header {
  padding: 5px;
}
.modal-header .close {
  margin: -1.5rem -2rem -1rem auto;
}
.history-table-wrapper {
  height: 350px;
  overflow-y: auto;
}
.modal-footer {
  border-top: none;
}
.btn-danger {
  background-color: #00ACEE;
  border-color: #00ACEE;
}
.modal-title {
  color: #7d7d7d;
  font-size: 14px;
  font-weight: 900;
}
.modal-header {
  border-bottom: 0px;
  margin-bottom: 10px;
}
.modal-body {
  padding: 5px;
}
.ma-blue-btn {
  color: #FFF !important; 
  background-color: #00acee !important;
  border: 1px solid #00acee !important;
  font-weight: 900;
  width: 120px;
}
.form-control { font-size: 14px; }
.hide_vmessage {
  display: none !important;
}
.show_vmessage {
  display: block !important;
}
@media (min-width: 320px) and (max-width: 991px) { 
  .modal-container {
    width: 100%;
  }
}
.ma-reset-password-btn, .ma-reset-password-btn:focus, .ma-reset-password-btn:active, .ma-reset-password-btn:hover {
  color: #FFF !important;
  background: #00ACEE !important;
  border: 1px solid #00ACEE !important;
  min-height: 35px;
  margin-top: -5px;
}
.mx-datepicker {
  width: 100%;
}
.mx-datepicker-popup {
  position: absolute !important;
}

</style>
<style>
.mx-datepicker-popup {
  position: absolute !important;
  z-index: 9999 !important;
}

</style>


// WEBPACK FOOTER //
// src/components/admin/onboarding_date_change_modal.vue